import NumberFormat from "react-number-format"

interface NumberFormatCustomProps {
    inputRef: (instance: NumberFormat | null) => void
    onChange: (event: { target: { name: string; value: string } }) => void
    name: string
    prefix?: boolean
}

export default function AuthorizationNumberInput(props: NumberFormatCustomProps) {
    const { prefix, inputRef, onChange, ...other } = props

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value.toString(),
                    },
                })
            }}
            isNumericString
            decimalScale={0}
            fixedDecimalScale={false}
            allowNegative={false}
            maxLength={49}
            allowLeadingZeros
        />
    )
}